import {
  FETCH_DATA_TANKERS,
  FETCH_DATA_TANKERS_ERROR,
  FETCH_DATA_TANKERS_SUCCESS,
  FETCH_DATA_TRUCKS,
  FETCH_DATA_TRUCKS_ERROR,
  FETCH_DATA_TRUCKS_SUCCESS,
  REQUEST_FULL_SCREEN_SUCCESS,
  SALUD_TIMELINE_SUCCESS
} from './FuelLevel.actions'

const fuelLevelState = {
  error: false,
  fullScreenRequested: false,
  loading: true,
  trucks: [],
  saludTimeline: null
}

/**
 * The fuel level' reducer.
 */
const fuelLevelReducer = (state = fuelLevelState, { payload, type }) => {
  switch (type) {
    case FETCH_DATA_TANKERS:
    case FETCH_DATA_TRUCKS: {
      return { ...state, loading: true, error: false }
    }
    case FETCH_DATA_TANKERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        trucks: payload.trucks
      }
    }
    case FETCH_DATA_TRUCKS_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: payload.posibleError,
        trucks: payload.trucks
      }
    }
    case FETCH_DATA_TANKERS_ERROR:
    case FETCH_DATA_TRUCKS_ERROR: {
      return {
        ...state,
        loading: false,
        error: true
      }
    }
    // each arrival replaces the previous document wholly — never merge
    case SALUD_TIMELINE_SUCCESS: {
      return {
        ...state,
        saludTimeline: payload.saludTimeline
      }
    }
    case REQUEST_FULL_SCREEN_SUCCESS: {
      return {
        ...state,
        fullScreenRequested: !state.fullScreenRequested
      }
    }
    default: {
      return state
    }
  }
}

export default fuelLevelReducer
